import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import ParametroOrganizacaoExclusao from '../exclusao';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { ApiError, ParametroOrganizacaoListagemProps } from '../../../services/tipos';

function ParametroOrganizacaoListagem(props: ParametroOrganizacaoListagemProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [showExclusao, setShowExclusao] = useState<boolean>(false);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [ParametroOrganizacao, setParametroOrganizacao] = useState<[{}]>([{}]);
    const [idParametroOrganizacao, setIdParametroOrganizacao] = useState<string>('');

    const handleHide = () => setShowWarning(false);

    const handleHideExclusao = () => setShowExclusao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Parâmetros da organização', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'Nome', tipo: 'string' },
            { nome: 'Valor', campo: 'Valor', tipo: 'string' },
        ],
    }

    const temPermissao = usuarioTemPermissao(token, 'parametros_organizacao_visualizar');
    const linkNovo = usuarioTemPermissao(token, 'parametros_organizacao_novo') ? `/organizacao/parametros/${props.match.params.idorganizacao}/novo` : '';
    const linkEdicao = usuarioTemPermissao(token, 'parametros_organizacao_editar') ? `/organizacao/parametros/${props.match.params.idorganizacao}/editar` : '';
    const handleExclusao = usuarioTemPermissao(token, 'parametros_organizacao_excluir') ? handleExcluir : undefined;

    useEffect(() => {
        if ((temPermissao) && (realizarConsulta)) {
            if (props.match.params.idorganizacao) {
                setCarregando(true);
                Promise.all([
                    api.get(`/Organizacao/${props.match.params.idorganizacao}`),
                    api.get(`/OData/ParametroOrganizacao?$filter=idOrganizacao eq ${props.match.params.idorganizacao}`)
                ]).then(response => {
                    setTimeout(() => {
                        setParametroOrganizacao(response[1].data.value);
                        setNomeOrganizacao(response[0].data.nome);
                        setRealizarConsulta(false);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
            }
        }
    }, [props.match.params.idorganizacao, temPermissao, realizarConsulta]);

    function handleExcluir(id: string) {
        setIdParametroOrganizacao(id);
        setShowExclusao(true);
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    textoNovo='Novo'
                    linkNovo={linkNovo}
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    linkEdicao={linkEdicao}
                    onExcluir={handleExclusao}
                    fonteDados={ParametroOrganizacao}
                    configuracoesTabela={configuracoesTabela}
                    descricao={`Listagem de parâmetros da organização: ${nomeOrganizacao}`}
                    linkVisualizacao={`/organizacao/parametros/${props.match.params.idorganizacao}/visualizar`} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <ParametroOrganizacaoExclusao
                    show={showExclusao}
                    tratarErro={tratarErro}
                    onHide={handleHideExclusao}
                    onExcluir={setRealizarConsulta}
                    idParametroOrganizacao={idParametroOrganizacao} />
            </RxlibLayout>
        </>
    );
}

export default ParametroOrganizacaoListagem;